import { getBusinessAppsData, setBusinessAppsData } from "./business-details-service";

// Set the prefix
export const localStoragePrefix = 'Hooper_bizdemo';
/**
 * Store a value in the localStorage with a specified key.
 *
 * @param {string} key - The key under which the value will be stored.
 * @param {any} value - The value to be stored.
 * @param {boolean} [stringify=false] - Optional parameter to indicate whether to stringify the value before storage.
 */
export const setSession = (key, value, stringify = false) => {
  // If stringify flag is true, convert the value to a JSON string.
  if (stringify) {
    value = JSON.stringify(value);
  }
  if (key.includes("_biz_accocunt_user_service_list")) {
    setBusinessAppsData(value);
  } else {
    // Use the localStorage API to set the provided value with the specified key.
    localStorage.setItem(`${localStoragePrefix}.${key}`, value);
  }

};

/**
 * Retrieve a value from localStorage using the specified key.
 *
 * @param {string} key - The key associated with the value in localStorage.
 * @param {boolean} [parse=false] - Optional parameter to indicate whether to parse the retrieved value as JSON.
 * @returns {string|Object|null} The retrieved value. If parse is true, it may return an object if the stored value was JSON.
 */
export const getSession = (key, parse = false) => {
  // Retrieve the value associated with the provided key from localStorage.
  let value = localStorage.getItem(`${localStoragePrefix}.${key}`);

  // If the parse flag is true, attempt to parse the value as JSON.
  if (parse && !key.includes("_biz_accocunt_user_service_list")) {
    value = JSON.parse(value || null);
    return value || {}; // Return the parsed value, which could be an object.
  }
  if (key.includes("_biz_accocunt_user_service_list")) {
    value = getBusinessAppsData();
  }
  return value || {}; // Return the retrieved value as-is (string or null).

};

/**
 * Remove a value from the browser's localStorage.
 *
 * @param {string} key - The key of the value to remove.
 * @param {boolean} clearAll - Flag to indicate whether to clear all localStorage items.
 */
export const removeSession = (key, clearAll = false) => {
  if (clearAll) {
    localStorage.clear();
    sessionStorage.clear();
  } else {
    localStorage.removeItem(`${localStoragePrefix}.${key}`);
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  }
};
